import { useRef } from "react";
import iphoneImage from "../../../assets/general/iphone-mobile.png";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

interface MarketingSectionProps {
  onContactUs: () => void;
}

export function MarketingSection({ onContactUs }: MarketingSectionProps) {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".left img", y: 60 });
  useScrollReveal(sectionRef, { targets: "h2, p, .contact-us-button", stagger: 0.12 });

  return (
    <section
      ref={sectionRef}
      id="section-two"
      className="section section-masthead text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="flex-column right-menu-padding left-section-padding">
        <div className="second-section section-vertical-padding">
          <div className="left">
            <img src={iphoneImage} alt="360PLUS mobile app" />
          </div>
          <div className="right">
            <div className="section-masthead__heading">
              <h2 className="h2 mt-0 mb-0">
                WE NEVER COMPROMISE WITH OUR PROJECTS.
              </h2>
            </div>
            <p>
              And neither should you. Genuinely crafted by industry leaders, 360PLUS is a
              collaboration software that provides more of what you need and less of what you
              don&apos;t. We believe the collectively used tools should be uncomplicated and
              affordable, while extending years of value.
            </p>
            <button className="contact-us-button contactus-button" onClick={onContactUs}>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
